// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__23iXg","label":"Completed_label__1o2pl"};